import React from 'react'

import { IHorizontalMenuItemProps } from './models'

export const HorizontalMenuItem: React.FC<IHorizontalMenuItemProps> = ({ children }) => {
  return <>{children}</>
}
